module.exports = __webpack_public_path__ + "img/partner3.6522813a.jpg";